export default "__VITE_ASSET__C5lu1NcH__"